const STORY_IMG = "/images/emmy-story.jpg";
const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

const TAGS = [
  "Born in China",
  "Raised in the US",
  "3 yrs in Korea",
  "Studied in France",
  "Indian family",
];

export default function StoryPanel() {
  return (
    <section className="panel" id="story" data-i="1" data-testid="panel-story">
      <div className="story-grid">
        <div className="story-photo reveal" style={d(0)}>
          <div className="frame">
            <img src={STORY_IMG} alt="Emmy with her family" data-testid="story-image" />
          </div>
        </div>

        <div className="story-text">
          <div className="eyebrow-v5 reveal" style={{ color: "var(--gold)", ...d(1) }}>
            My story
          </div>
          <h2 className="story-h reveal" style={d(2)}>
            Five cultures.
            <br />
            One <em>intentional</em> life.
          </h2>
          <p className="story-body reveal" style={d(3)}>
            Chinese by birth, American by upbringing, shaped by years in Korea and
            France, and rooted in an Indian family through marriage. I didn't grow up
            with one culture — I grew up with many, and I'm weaving all of it into a
            life that finally feels like mine.
          </p>
          <p className="story-body reveal" style={d(4)}>
            This is where I share what I'm learning: the rituals, the homemaking, the
            honest middle of it all.
          </p>
          <div className="story-tags reveal" style={d(5)}>
            {TAGS.map((t) => (
              <span className="tag" key={t}>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
